import { InviteTeamForm } from '@/components/onboarding/InviteTeamForm';

export default function OnboardingInvitePage() {
  return (
    <div className='bg-slate-50 dark:bg-stone-950 flex min-h-svh flex-col items-center justify-center p-6 md:p-10'>
      <InviteTeamForm />
    </div>
  );
}
